import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { debounce } from "../../utils/common";
import { useSelector } from "react-redux";

const DefaultLayout = ({
  screenMobile = true,
  headerVisible = true,
  sideBarVisible = true,
  showSearch = true,
  children,
}) => {
  const configData = useSelector((state) => state.configSlice);
  const navigate = useNavigate();
  const [mobileShowSideBar, setMobileShowSideBar] = useState(false);

  const [parentCategory, setParentCategory] = useState({
    id: null,
    name: null,
  });

  const handleBackButton = () => {
    navigate(parentCategory?.id ? `/category/${parentCategory.id}` : `/category/${configData.config["3dAssetsId"]}`);
  };

  const handleDebounceBackClick = debounce(handleBackButton, 300);

  return (
    <>
      {headerVisible && screenMobile && (
        <Header
          mobileShowSideBar={mobileShowSideBar}
          setMobileShowSideBar={setMobileShowSideBar}
          parentCategory={parentCategory}
          handleDebounceBackClick={handleDebounceBackClick}
          showSearch={showSearch}
        />
      )}
      <div className="bodynside">
        {sideBarVisible && (
          <Sidebar
            mobileShowSideBar={mobileShowSideBar}
            setMobileShowSideBar={setMobileShowSideBar}
            parentCategory={parentCategory}
            setParentCategory={setParentCategory}
            handleDebounceBackClick={handleDebounceBackClick}
          />
        )}
        {children}
      </div>
    </>
  );
};

export default DefaultLayout;
